  document.addEventListener('DOMContentLoaded', function () {
    const navLinks = document.querySelectorAll('.js-anchor');
    const navBar = document.querySelector('.am-nav-sticky');
    const bannerBlocks = document.querySelectorAll('.am-block-banner-wrapper');

    navLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('data-target');
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const navHeight = navBar ? navBar.offsetHeight : 0;

          let stickyTop = 0;
          if (navBar) {
            const style = window.getComputedStyle(navBar);
            stickyTop = parseInt(style.top) || 0;
          }

          const targetPosition =
            targetElement.getBoundingClientRect().top + window.pageYOffset - navHeight - stickyTop - 20;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          });
        }
      });
    });

    window.addEventListener('scroll', () => {
      let current = '';
      const navHeight = navBar ? navBar.offsetHeight : 0;

      bannerBlocks.forEach((block) => {
        const blockTop = block.offsetTop;
        if (pageYOffset >= blockTop - navHeight - 200) {
          current = block.getAttribute('id');
        }
      });

      navLinks.forEach((link) => {
        link.classList.remove('active');
        if (link.getAttribute('data-target') === current) {
          link.classList.add('active');

          const parent = link.parentElement;
          if (parent && parent.parentElement) {
            const navList = parent.parentElement;
            navList.scrollLeft = parent.offsetLeft - navList.clientWidth / 2 + parent.clientWidth / 2;
          }
        }
      });
    });

    const atcButtons = document.querySelectorAll('.js-am-add-to-cart');

    atcButtons.forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        const variantId = this.getAttribute('data-variant-id');
        if (!variantId) return;

        const originalText = this.innerText;
        this.innerText = 'Adding...';
        this.classList.add('loading');

        let formData = {
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            this.innerText = 'Added';
            setTimeout(() => {
              this.innerText = originalText;
              this.classList.remove('loading');
            }, 2000);

            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
              })
            );

            const cartNotification = document.querySelector('cart-notification');
            if (cartNotification) {
              cartNotification.renderContents(data);
              cartNotification.open();
            } else if (document.querySelector('cart-drawer')) {
              const cartDrawer = document.querySelector('cart-drawer');
              fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble')
                .then((res) => res.json())
                .then((sections) => {
                  if (sections['cart-drawer']) {
                    const drawerContent = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                    const innerDrawer = cartDrawer.querySelector('.drawer__inner') || cartDrawer;
                    if (innerDrawer) innerDrawer.innerHTML = drawerContent.querySelector('.drawer__inner').innerHTML;
                  }
                  if (sections['cart-icon-bubble']) {
                    const bubble = document.getElementById('cart-icon-bubble');
                    if (bubble) bubble.innerHTML = sections['cart-icon-bubble'];
                  }
                  if (cartDrawer.open) cartDrawer.open();
                  else cartDrawer.classList.add('active');
                });
            }
          })
          .catch((error) => {
            console.error('Error:', error);
            this.innerText = 'Error';
          });
      });
    });
  });